import FormTemplateList from '@/components/admin/formtemplate/FormTemplateList'
import FormTemplate from '@/components/admin/formtemplate/FormTemplate'
import auth from './../auth'

export default [
  {
    path: '/admin/forms/',
    name: 'FormTemplateList',
    component: FormTemplateList,
    beforeEnter: auth.ifAuthenticated
  },
  {
    path: '/admin/form/:id?',
    name: 'FormTemplate',
    component: FormTemplate,
    beforeEnter: auth.ifAuthenticated
  }
]
